// React imports  
import React, { useState, useRef, useEffect, useCallback, useContext } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

// MUI imports **************************************************************************/
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import AppBar from '@mui/material/AppBar';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Chat from "./Chat";
import Settings from "./Settings";
import { ONBOARDING_ENABLED, MFA_GATE_ENABLED } from '../env';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Tooltip, Snackbar, Alert } from '@mui/material';
// ******************************************************************************************/

//import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from '../theme'; // â† importa tu theme personalizado
import { signOut, fetchUserAttributes, getCurrentUser } from 'aws-amplify/auth';
// Agregado para el menÃº de la izquierda
import {
  Drawer,
  IconButton,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  TextField
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import HistoryIcon from '@mui/icons-material/History';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PsychologyIcon from '@mui/icons-material/Psychology';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
// Importar useMediaQuery para detectar tamaÃ±o de pantalla
import { useMediaQuery } from '@mui/material';
//******************************************************************************************/

// API Imports ***************************************************************************/
//import createConversationApi from '../api/CreateConversation'; // API Rest
import {
  createConversation,
  getSessionsByUser,
  renameConversation,
  deleteConversation
} from '../api/ConversationApi'; // API Rest (whisperbi-back-security)
import summarizeTextWithClaude from '../api/SummarizeTextWithClaude.js'; // API Bedrock
import ConversationStorage from '../utils/ConversationStorage.js';
import ChatStreamSimulator from '../utils/ChatStreamSimulator.js'; // API Dynamo
import HeaderWithDropdown from './HeaderWithDropdown';
import OnboardingDialog from './OnboardingDialog';
import MfaSetupDialog from './MfaSetupDialog';
import UserProfileService from '../services/UserProfileService';
import SemanticModels from '../pages/semanticmodel/semanticmodel/SemanticModels';
import MyDashboards from '../admin/home/pages/dashboards/MyDashboards';
import DashboardDetail from '../admin/home/pages/dashboards/DashboardDetail';
import { DataContext } from '../context/DataContext';
import WorkspaceSelector from './WorkspaceSelector.jsx';
import AgentSelector from './AgentSelector.jsx';
import { HEADER_HEIGHT } from './headerHeight';
import { useAppTheme } from '../themes/ThemeController';
//**************************************************************************************** */

function LayoutApp() {

  const location = useLocation()
  const navigate = useNavigate();
  const { pathname } = location
  const CHAT_ROUTE = '/layautapp';
  const DASHBOARDS_ROUTE = `${CHAT_ROUTE}/tableros`;
  const [userInfo, setUserInfo] = useState({})

  const { selectedWorkspace, refreshSession, setAccountId } = useContext(DataContext);

  const [userName, setUserName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [showSettings, setShowSettings] = React.useState(false);
  // Mis tableros se muestra en el contenido principal, junto al menú de chats.
  const isDashboardsView = pathname.startsWith(DASHBOARDS_ROUTE) && !showSettings;
  const { dashboardId } = useParams();
  // Misma condición con la que el contenido principal muestra el chat.
  const isChatView = pathname !== '/semanticmodel' && !showSettings && !isDashboardsView;

  /*** Ajustes para el menu ***************************************/
  // Mobile device detection
  // Tema de MUI con los colores del tema activo (src/themes/*.css).
  const { muiTheme } = useAppTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Teléfonos y tablets (< md): menú superpuesto y cerrado al entrar; en PC
  // fijo al lado (el contenido se corre con ml/width, ver "Main content").
  // noSsr: valor real desde el primer render (sin esto el menú se abría un
  // instante en teléfonos y tablets antes de cerrarse).
  const isDrawerOverlay = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const [drawerOpen, setDrawerOpen] = useState(!isDrawerOverlay);
  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };
  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev);
  };
  const DRAWER_WIDTH = isMobile ? 240 : 260;
  //***************************************************************/


  /*** Manejo de menus ********************************************/

  const [chatList, setChatList] = useState([]);
  const [newChatCounter, setNewChatCounter] = useState(1);
  // Manejo de session
  const [sessionIdFromChat, setSessionIdFromChat] = useState(''); // Estado para recibir el sessionId de Chat
  const chatGenerateSessionId = useRef(null);
  const [selectedSessionId, setSelectedSessionId] = useState(null);

  /** Onboarding dialog state **/
  const [profileChecked, setProfileChecked] = useState(false);
  const [showOnboardingDialog, setShowOnboardingDialog] = useState(false);
  const [profileDefaults, setProfileDefaults] = useState({
    companyName: '',
    employeesCount: '',
  });
  // No bloqueante -- se muestra cuando no se pudo CONFIRMAR el estado del
  // perfil (network/401 transitorio, etc.), distinto de "perfil no existe"
  // (404 real). Ver fetchData() más abajo.
  const [profileCheckError, setProfileCheckError] = useState(false);

  const onboardingEnabled = ONBOARDING_ENABLED !== false;

  const setOnboardingDialogVisibility = useCallback((shouldShow) => {
    setShowOnboardingDialog(onboardingEnabled ? shouldShow : false);
  }, [onboardingEnabled, setShowOnboardingDialog]);

  /** MFA gate state -- ver fetchData() más abajo: se evalúa junto con el
   * perfil (profile.security.mfa_required/mfa_enabled, ver user-account/
   * app.py::get_user_account) SOLO cuando el onboarding ya está resuelto
   * (hasProfile true), para no mostrar dos diálogos bloqueantes a la vez. **/
  const [showMfaDialog, setShowMfaDialog] = useState(false);
  const mfaGateEnabled = MFA_GATE_ENABLED !== false;

  const setMfaDialogVisibility = useCallback((shouldShow) => {
    setShowMfaDialog(mfaGateEnabled ? shouldShow : false);
  }, [mfaGateEnabled, setShowMfaDialog]);

  // profile === null solo ocurre en un 404 real de GET /useraccount/{id}
  // (ver UserProfileService.js::fetchWithAuth) -- es un "no tiene perfil"
  // CONFIRMADO, correcto mostrar onboarding. Cualquier otra falla (red,
  // 401/403 transitorio, 500, etc.) NO debe tratarse igual -- eso lo
  // maneja checkProfile() con reintento + fail-open.
  const applyProfile = useCallback((profile) => {
    if (profile) {
      const normalizedCompanyName =
        profile.companyName ||
        profile.company_name ||
        profile.company?.name ||
        '';
      const normalizedEmployees =
        profile.employeesCount ??
        profile.employees_count ??
        profile.company?.employees_count ??
        profile.numberOfEmployees;
      const normalizedDefaults = {
        companyName: normalizedCompanyName,
        employeesCount:
          normalizedEmployees !== undefined && normalizedEmployees !== null
            ? String(normalizedEmployees)
            : '',
      };

      setProfileDefaults(normalizedDefaults);

      const hasProfile = Boolean(normalizedCompanyName) && normalizedEmployees !== undefined && normalizedEmployees !== null;
      setOnboardingDialogVisibility(!hasProfile);

      // Gate de MFA: solo se evalúa si el onboarding ya está resuelto
      // (hasProfile), para no encimar dos modales bloqueantes. Fail-open
      // (no forzar el gate) si no se pudo determinar el estado real -- un
      // fetch fallido no debe poder bloquear el acceso de todo un tenant a
      // la app.
      const mfaRequired = Boolean(profile?.security?.mfa_required);
      const mfaEnabled = Boolean(profile?.security?.mfa_enabled);
      setMfaDialogVisibility(hasProfile && mfaRequired && !mfaEnabled);
    } else {
      setProfileDefaults({
        companyName: '',
        employeesCount: '',
      });
      setOnboardingDialogVisibility(true);
      setMfaDialogVisibility(false);
    }
  }, [setOnboardingDialogVisibility, setMfaDialogVisibility]);

  // Chequeo de perfil compartido entre el mount inicial y el botón
  // "Reintentar" del aviso no bloqueante (ver profileCheckError). Un solo
  // reintento, forzando refresco de sesión primero (cubre el caso más
  // probable: token de Amplify todavía no hidratado justo tras el login).
  // Si el reintento también falla, fail-open -- no forzar el onboarding
  // sobre un usuario que podría ya tener perfil (ver Bug B, análisis de
  // 2026-09-22).
  const checkProfile = useCallback(async () => {
    try {
      const profile = await UserProfileService.getProfile();
      setProfileCheckError(false);
      applyProfile(profile);
    } catch (error) {
      console.warn('Error al consultar el perfil del usuario, reintentando tras refrescar sesión:', error);
      try {
        await refreshSession();
        const profile = await UserProfileService.getProfile();
        setProfileCheckError(false);
        applyProfile(profile);
      } catch (retryError) {
        console.error('Error al consultar el perfil del usuario tras reintentar:', retryError);
        setOnboardingDialogVisibility(false);
        setMfaDialogVisibility(false);
        setProfileCheckError(true);
      }
    } finally {
      setProfileChecked(true);
    }
  }, [applyProfile, refreshSession, setOnboardingDialogVisibility, setMfaDialogVisibility]);


  /*********************************************************************
   * Manage new chat from layout to Chat
   *********************************************************************/
  const handleCreateNewChat = async () => {

    if (pathname !== CHAT_ROUTE) {
      navigate(CHAT_ROUTE);
    }

    if (isDrawerOverlay) {
      setDrawerOpen(false);
    }

    //console.log('Se hizo clic en el botÃ³n para crear un nuevo chat.');

    // Si el componente Settings estÃ¡ visible, lo ocultamos para mostrar el Chat
    if (showSettings) {
      setShowSettings(false);
    }

    if (chatGenerateSessionId.current) {
      //console.log('LayoutApp estÃ¡ llamando a la funciÃ³n de Chat para generar un nuevo ID.');
      chatGenerateSessionId.current(); // Llama a la funciÃ³n de Chat para actualizar su 
      //console.log('ID de sesiÃ³n generado en Chat:');
    } else {
      console.warn('La función para generar Session ID de Chat no está disponible.');
    }
    /**
     * Nota, aqui no se actualiza inmediatamente sessionIdFromChat
     * Se usa el useEffect para actualizarlo
     * 
     */

  };


  const handleChangeChatName = (chatId, newName) => {
    console.log('TITULO_MENU:handleChangeChatName:', firstQueryFromChat);

    setChatList(prevChatList =>
      prevChatList.map(chat =>
        chat.session_id === chatId
          ? {
            ...chat,
            name: newName,
            shortName: newName.length > 20 ? newName.substring(0, 20) + '...' : newName
          }
          : chat
      )
    );
  };




  // FunciÃ³n para actualizar el nombre de un chat por su session_id
  const updateChatName = async (sessionId, newName) => {
    //console.log('TITULO_MENU:updateChatName:', firstQueryFromChat);
    setChatList(prevChatList =>
      prevChatList.map(chat =>
        chat.session_id === sessionId
          ? {
            ...chat,
            name: newName,
            shortName: newName.length > 20 ? newName.substring(0, 20) + '...' : newName
          }
          : chat
      )
    );
  };


  /*********************************************************************
  * Recibe te first query from Chat.js
  *********************************************************************/
  const [firstQueryFromChat, setFirstQueryFromChat] = useState("");
  const [textQueryFromChat, setTextQueryFromChat] = useState("");

  // Esta funciÃ³n se pasarÃ¡ a Chat.js
  const handleFirstQueryFromChat = (query) => {
    setFirstQueryFromChat(query);
    //console.log("*** Received First query from Chat.js:", query);
  };

  // Esta funciÃ³n se pasarÃ¡ a Chat.js
  const handleTextQueryFromChat = (query) => {
    setTextQueryFromChat(query);
    //console.log("*** Received Text query from Chat.js:", query);
  };
  /************************************************************************/



  /************************************************************************
  * Cambio de la session en Chat.js
  *************************************************************************/
  const handleSessionIdChange = (newSessionId) => {
    //console.log('***handleSessionIdChange: ', newSessionId)
    //console.log('***sessionIdFromChat: ', sessionIdFromChat)
    if (newSessionId !== sessionIdFromChat) {
      setSessionIdFromChat(newSessionId);
      //console.log('*** SE ACTUALIZA LA SESSION EN LAYOUT:');
    }
  };

  const handleChatReady = (generateFunction) => {
    chatGenerateSessionId.current = generateFunction;
    ////console.log('*** NUEVA CONVERSACION [handleChatReady]');
  };


  //***************************************************************/


  /***************************************************************
  *Manejo del historial
  *****************************************************************/
  const loadChatHistory = (selectedSessionId) => {
    if (pathname !== CHAT_ROUTE) {
      navigate(CHAT_ROUTE);
    }
    //console.log('***loadChatHistory: ', selectedSessionId)

    if (isDrawerOverlay) {
      setDrawerOpen(false);
    }

    // Si el componente Settings estÃ¡ visible, lo ocultamos al cargar un chat del historial
    if (showSettings) {
      setShowSettings(false);
    }

    setSelectedSessionId(selectedSessionId);
  };


  /***************************************************************
  * Settings management
  *****************************************************************/
  const handleToggleSettings = () => {
    if (pathname !== CHAT_ROUTE) {
      navigate(CHAT_ROUTE);
    }
    setShowSettings(prev => !prev);
  };

  /***************************************************************
  * Delete item selected
  *****************************************************************/
  const deleteChat = async (sessionId, event) => {
    // Detener la propagaciÃ³n para evitar que se active el onClick del ListItem
    event.stopPropagation();

    // Delete content of sessionId from localStorage
    ConversationStorage.deleteConversation(sessionId);

    // Delete item via backend web service
    const apiResult = await deleteConversation(sessionId, userName);

    if (!apiResult.success) {
      console.error('Error al eliminar la conversación:', apiResult.error);
      return;
    }

    // Eliminar el chat de la lista solo si el backend confirmÃ³ el borrado
    setChatList(prevChatList =>
      prevChatList.filter(chat => chat.session_id !== sessionId)
    );

    // Si el chat eliminado es el que estÃ¡ seleccionado, limpiar la selecciÃ³n
    if (selectedSessionId === sessionId) {
      setSelectedSessionId(null);
    }
  };

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [chatToDelete, setChatToDelete] = useState(null);

  const handleDeleteClick = (chatId, event) => {
    event.stopPropagation(); // Evitar que se seleccione el chat
    setChatToDelete(chatId); // Guardamos el ID del chat que se quiere eliminar
    setDeleteDialogOpen(true); // Abrimos el diÃ¡logo
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setChatToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (chatToDelete) {
      await deleteChat(chatToDelete, { stopPropagation: () => { } }); // Ejecuta tu funciÃ³n actual
    }
    handleCloseDeleteDialog(); // Cerramos el diÃ¡logo
  };


  /*********************************************************************
   * ActualizaciÃ³n de nombre de chat
   **********************************************************************/
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [newChatName, setNewChatName] = useState('');

  // ðŸ‘‰ Para diÃ¡logo de confirmaciÃ³n de eliminaciÃ³n



  // FunciÃ³n para abrir el diÃ¡logo de ediciÃ³n
  const handleEditClick = (chatId, chatName, event) => {
    event.stopPropagation(); // Prevenir que se active el onClick del ListItem
    setCurrentChatId(chatId);
    setNewChatName(chatName);
    setEditDialogOpen(true);
  };

  //funcion para abrir el dialogo para eliminar


  // FunciÃ³n para cerrar el diÃ¡logo de ediciÃ³n
  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setCurrentChatId(null);
    setNewChatName('');
  };

  //funcion para cerrar el dialogo de eliminar


  // FunciÃ³n para guardar el nuevo nombre del chat
  const handleSaveNewName = async () => {

    //console.log('handleSaveNewName: ', currentChatId, newChatName);

    // Actualizar el nombre en la lista local **************
    setChatList(prevChatList =>
      prevChatList.map(chat =>
        chat.session_id === currentChatId
          ? {
            ...chat, name: newChatName,
            shortName: newChatName.length > 20 ? newChatName.substring(0, 20) + '...' : newChatName
          }
          : chat
      )
    );


    // Update session Name via backend web service **************
    const updateResponse = await renameConversation(userName, currentChatId, newChatName)
      .then(response => {
        if (response.success) {
          //console.log('Nombre de sesiÃ³n actualizado:', response.data);
        } else {
          console.error('Error al actualizar el nombre de la sesiÃ³n:', response.error);
        }
      })
      .catch(error => {
        console.error('Error al actualizar el nombre de la sesiÃ³n:', error);
      });

    // AquÃ­ tambiÃ©n podrÃ­a ir la lÃ³gica para actualizar el nombre en la base de datos
    //console.log(`Actualizando chat ${currentChatId} con nombre: ${newChatName}`);

    // Cerrar el diÃ¡logo despuÃ©s de guardar
    handleCloseEditDialog();
  };

  // useEffect para cerrar el drawer cuando cambia a vista mÃ³vil
  useEffect(() => {
    if (isDrawerOverlay) {
      setDrawerOpen(false);
    }
  }, [isDrawerOverlay]);


  const effectRan = React.useRef(false);
  useEffect(() => {
    if (!effectRan.current) {
      //console.log("effect applied - only on the FIRST mount");

      const fetchData = async () => {
        //console.log("Layout");

        // User Data
        const currentUser = await getCurrentUser();
        const currectUserName = currentUser.signInDetails.loginId.split('@')[0].charAt(0).toLowerCase() + currentUser.signInDetails.loginId.split('@')[0].slice(1).toLowerCase()
        //console.log("Current User: ", currectUserName);
        setUserName(currectUserName);
        setEmail(currentUser.signInDetails.loginId);
        const userAttributes = await fetchUserAttributes();

        //setChatList(getSessionList);

        if ('name' in userAttributes) {
          setUserName(userAttributes.name);
        }
        //console.log(userAttributes);

        // Get session list for the user ********************************
        const response = await getSessionsByUser(currectUserName);
        if (response.success) {
          const sessions = response.data;
          // Del mÃ¡s antiguo al mÃ¡s nuevo
          sessions.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
          // Creamos un nuevo campo con el nombre corto
          sessions.forEach(item => {
            item.shortName = item.name.length > 20
              ? item.name.substring(0, 20) + "..."
              : item.name;
          });

          setChatList(sessions);
        } else {
          console.error("Error al cargar sesiones:", response.error);
        }
        //*******************************************************************/

        if (!onboardingEnabled) {
          setProfileDefaults({
            companyName: '',
            employeesCount: '',
          });
          setOnboardingDialogVisibility(false);
          setProfileChecked(true);
          return;
        }

        await checkProfile();
      }
      fetchData()
        // catch any error
        .catch(error => {
          console.error(error);
          // Fail-open: un error en OTRA parte del efecto (sesión, lista de
          // chats, etc.) no tiene relación con el estado del perfil -- no
          // forzar el onboarding sobre esa base.
          setOnboardingDialogVisibility(false);
          setMfaDialogVisibility(false);
          setProfileCheckError(true);
          setProfileChecked(true);
        });
    }

    return () => effectRan.current = true;
  }, [onboardingEnabled, setOnboardingDialogVisibility, checkProfile]);


  // Deseleccionar el chat abierto cuando cambia el workspace *************************************
  // (no dispara en el primer mount, que es cuando se restaura el workspace guardado en localStorage)
  const prevWorkspaceIdRef = useRef(undefined);
  useEffect(() => {
    const currentWorkspaceId = selectedWorkspace?.semantic_workspace_id ?? null;
    const prevWorkspaceId = prevWorkspaceIdRef.current;
    if (prevWorkspaceId !== undefined && prevWorkspaceId !== null && prevWorkspaceId !== currentWorkspaceId) {
      setSelectedSessionId(null);
    }
    prevWorkspaceIdRef.current = currentWorkspaceId;
  }, [selectedWorkspace]);


  // Actualizar el nombre del chat cuando cambia sessionIdFromChat ********************************
  useEffect(() => {

    if (sessionIdFromChat) {

      // Verificar si ya existe un chat con este session_id
      const sessionExists = chatList.some(chat => chat.session_id === sessionIdFromChat);
      if (!sessionExists) {
        // Solo crear el chat si no existe
        createNewChatWithSessionId(sessionIdFromChat);
      } else {
        //console.log(`Ya existe un chat con el session_id: ${sessionIdFromChat}. No se crearÃ¡ uno nuevo.`);
      }

    }
  }, [sessionIdFromChat]); // â† Solo se ejecuta cuando sessionIdFromChat cambia


  useEffect(() => {
    //console.log('TITULO_MENU:useEffect');
    //console.log('TITULO_MENU:firstQueryFromChat ', firstQueryFromChat);
    //console.log('TITULO_MENU:textQueryFromChat ', textQueryFromChat);
    //console.log('TITULO_MENU:sessionIdFromChat ', sessionIdFromChat);

    // Verificar que todas las variables necesarias estÃ©n disponibles
    const isFirstQuery = firstQueryFromChat === "true" || firstQueryFromChat === true;
    const hasValidText = textQueryFromChat && textQueryFromChat.trim() !== '';
    const hasValidSession = sessionIdFromChat && sessionIdFromChat.trim() !== '';

    if (!isFirstQuery || !hasValidText || !hasValidSession) {
      //console.log('TITULO_MENU:Condiciones no cumplidas:', { isFirstQuery, hasValidText, hasValidSession });
      return;
    }

    const targetChat = chatList.find(chat => chat.session_id === sessionIdFromChat);
    if (!targetChat) {
      return;
    }

    // GeneraciÃ³n de resumen y actualizaciÃ³n de menu
    const fetchData = async () => {
      try {
        const summarizeTex = await summarizeTextWithClaude(textQueryFromChat);
        const summarizeTexCorto = summarizeTex.length > 18
          ? summarizeTex.substring(0, 20) + "..."
          : summarizeTex;

        if (targetChat.name !== summarizeTexCorto) {
          updateChatName(sessionIdFromChat, summarizeTexCorto);
        }
        const updateResponse = await renameConversation(userName, sessionIdFromChat, summarizeTex);
        //console.log('TITULO_MENU:Chat actualizado correctamente');
      } catch (error) {
        console.error('TITULO_MENU:Error al procesar el chat:', error);
      }
    };

    fetchData();

  }, [firstQueryFromChat, textQueryFromChat, sessionIdFromChat, chatList]);


  /************************************************************************************
   *  FunciÃ³n auxiliar para crear un nuevo chat con un ID de sesiÃ³n especÃ­fico
   * **********************************************************************************/
  // FunciÃ³n auxiliar para introducir un retraso
  const delay = ms => new Promise(res => setTimeout(res, ms));
  const createNewChatWithSessionId = async (sessionId) => {
    await delay(1500); // Simular un retraso de 500 ms
    const newChatName = `Nueva conversación`;

    // Actualizar el estado local, colocando el nuevo chat al principio
    setChatList(prevChatList => [
      {
        session_id: sessionId,
        name: newChatName,
        shortName: newChatName.length > 20 ? newChatName.substring(0, 20) + '...' : newChatName,
        workspace_id: selectedWorkspace?.semantic_workspace_id
      },
      ...prevChatList]
    );
    setNewChatCounter(prevCounter => prevCounter + 1);

    // Se selecciona el item creado
    setSelectedSessionId(sessionId); // Marca el nuevo chat como seleccionado

    //console.log('chatList actualizado con nuevo elemento al principio:', sessionId);
    //console.log('*** newChatName: ', newChatName);

    // Crear el registro de la conversación vía el servicio web
    try {
      const apiResult = await createConversation(sessionId, newChatName, userName, selectedWorkspace?.semantic_workspace_id);
      if (apiResult.success) {
        console.log('Registro creado exitosamente:', apiResult.data.itemId);
      } else {
        console.error('Error al crear el registro de la conversación:', apiResult.error || 'Resultado inesperado');

        // Si falla la creaciÃ³n, quitamos el item del chatList local
        setChatList(prevChatList => prevChatList.filter(chat => chat.session_id !== sessionId));
      }
    } catch (error) {
      console.error('Error al crear conversaciÃ³n:', error);
      // TambiÃ©n eliminamos del chatList local en caso de error
      setChatList(prevChatList => prevChatList.filter(chat => chat.session_id !== sessionId));
    }
  };

  //************************************************************************************************ */

  // Estado local para la bÃºsqueda
  const [searchQuery, setSearchQuery] = useState("");

  // Lista filtrada directamente desde chatList
  const displayedChats = chatList.filter(chat =>
    chat.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
    (!selectedWorkspace || chat.workspace_id === selectedWorkspace.semantic_workspace_id)
  );

  ///////



  const defaultTheme = createTheme({
    palette: {
      primary: {
        main: "#48C3C4"
      },
      secondary: {
        main: "#D41773"
      },
    }
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function handleSignOut() {
    try {
      await signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  return (

    <ThemeProvider theme={muiTheme || theme}>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' }, backgroundColor: 'var(--wb-x-bg-ffffff, #ffffffff)' }} />
      <CssBaseline />

      {/* Sidebar */}
      {/* BotÃ³n para abrir el Drawer cuando estÃ¡ cerrado - modificado para ser mÃ¡s visible en mÃ³vil */}
      {!drawerOpen && !isDrawerOverlay && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: 'fixed',
            top: 16,
            left: 16,
            zIndex: 1301,
            backgroundColor: 'var(--wb-surface-white)',
            color: 'var(--wb-x-text-000000, #000000)',
            border: '1px solid var(--wb-x-border-cccccc, #ccc)',
            borderRadius: '50%',
            boxShadow: '0px 4px 10px var(--wb-x-shadow-00000033, rgba(0,0,0,0.2))',
            '&:hover': {
              backgroundColor: 'var(--wb-x-bg-f0f0f0, #f0f0f0)'
            }
          }}
        >
          {drawerOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      )}



      {/*********************************
         Lateral aplication menu bar
      *********************************/}
      {/* Drawer modificado para ser temporal en mÃ³vil */}

      <Drawer
        variant={isDrawerOverlay ? "temporary" : "persistent"}
        open={drawerOpen}
        anchor="left"
        onClose={isDrawerOverlay ? toggleDrawer : undefined}
        sx={{
          // Solo el menú fijo (PC) ocupa espacio; el superpuesto no.
          width: !isDrawerOverlay && drawerOpen ? DRAWER_WIDTH : 0,
          flexShrink: 0,
          transition: 'width 0.3s',
          whiteSpace: 'nowrap',
          [`& .MuiDrawer-paper`]: {
            width: DRAWER_WIDTH,
            transition: 'width 0.3s',
            overflowX: 'hidden',
            boxSizing: 'border-box',
            background: 'linear-gradient(180deg, var(--wb-bg-header) 0%, var(--wb-x-bg-080808, #080808ff) 100%)',
            color: 'var(--wb-text-strong)',
            borderRight: '1px solid var(--wb-x-border-3c3c52, #3c3c52ff)',
            // El encabezado fijo queda encima del menú: empezar debajo de él
            // (antes tapaba el botón de cerrar y el selector de workspace).
            pt: { xs: `${HEADER_HEIGHT.xs + 16}px`, sm: `${HEADER_HEIGHT.sm + 16}px` },
            px: 2,
          },
        }}
      >
        <Box sx={{
          mb: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: 'orange'
        }}>
          <IconButton onClick={toggleDrawer} sx={{ color: 'var(--wb-x-text-cccac1, #cccac1ff)' }}>
            <ChevronLeftIcon />
          </IconButton>
        </Box>

        <List sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

          <Box sx={{ px: 1, mb: 1 }}>
            <WorkspaceSelector />
            <AgentSelector />
          </Box>

          {/* Campo de Administración */}
          <ListItem
            button
            component={Link}
            to="/admin/home/panel"
            selected={pathname.startsWith('/admin/home')}
            onClick={() => {
              if (isDrawerOverlay) {
                setDrawerOpen(false);
              }
            }}
            sx={{
              borderRadius: '8px',
              mb: 0.5,
              ':hover': {
                backgroundColor: 'var(--wb-x-bg-1b1b1b, #1b1b1bff)'
              },
              '&.Mui-selected': {
                backgroundColor: 'var(--wb-x-bg-facc1529, rgba(250, 204, 21, 0.16))',
                '&:hover': {
                  backgroundColor: 'var(--wb-x-bg-eab30842, rgba(234, 179, 8, 0.26))'
                }
              }
            }}
          >
            <ListItemIcon>
              <PsychologyIcon
                sx={{
                  color: 'var(--wb-x-text-b9b9b9, #b9b9b9ff)'
                }}
              />
            </ListItemIcon>
            <ListItemText primary="Diseñador I.A." />
          </ListItem>

          <ListItem
            button
            onClick={handleCreateNewChat}
            selected={pathname === CHAT_ROUTE && !showSettings && !selectedSessionId}
          >
            <ListItemIcon>
              <ChatBubbleOutlineIcon
                sx={{
                  color: "var(--wb-x-text-b9b9b9, #b9b9b9ff)",
                }}
              />
            </ListItemIcon>
            <ListItemText primary="Nueva conversación" />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              if (pathname !== CHAT_ROUTE) {
                navigate(CHAT_ROUTE);
              }
              if (showSettings) {
                setShowSettings(false);
              }
              if (isDrawerOverlay) {
                setDrawerOpen(false);
              }
            }}
            selected={pathname === CHAT_ROUTE && !showSettings && selectedSessionId === null}
          >
            <ListItemIcon>
              <HistoryIcon
                sx={{
                  color: 'var(--wb-x-text-b9b9b9, #b9b9b9ff)'
                }} />
            </ListItemIcon>
            <ListItemText primary="Historial" />
          </ListItem>
          <ListItem
            button
            component={Link}
            to={DASHBOARDS_ROUTE}
            selected={isDashboardsView}
            onClick={() => {
              if (showSettings) {
                setShowSettings(false);
              }
              if (isDrawerOverlay) {
                setDrawerOpen(false);
              }
            }}
          >
            <ListItemIcon>
              <DashboardOutlinedIcon
                sx={{
                  color: 'var(--wb-x-text-b9b9b9, #b9b9b9ff)'
                }} />
            </ListItemIcon>
            <ListItemText primary="Mis tableros" />
          </ListItem>


          {/* Campo de bÃºsqueda */}
          <Box sx={{ p: 1 }}>
            <TextField
              variant="outlined"
              placeholder="Buscar chat..."
              size="small"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                sx: {
                  backgroundColor: "var(--wb-x-bg-111111, #111111ff)",
                  borderRadius: 0.8,
                  border: '1px solid var(--wb-x-border-5b5b5b, #5b5b5bff)',
                  color: "var(--wb-text-strong)",
                  "& input::placeholder": {
                    color: "var(--wb-text-strong)", // <-- Color del placeholder
                    opacity: 0.5
                  }
                }
              }}
            />
          </Box>

          {/* Lista de chats (ya filtrada directamente) */}
          <List sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {displayedChats.map((chat) => (
              <ListItem
                button
                key={chat.session_id}
                onClick={() => loadChatHistory(chat.session_id)}
                selected={selectedSessionId === chat.session_id}
                sx={{
                  ":hover": {
                    backgroundColor: 'var(--wb-x-bg-1b1b1b, #1b1b1bff)'
                  },
                  borderRadius: '8px',
                  mb: 0.5,
                  '&.Mui-selected': {
                    backgroundColor: 'var(--wb-x-bg-00fbff33, rgba(0, 251, 255, 0.2))',
                    '&:hover': {
                      backgroundColor: 'var(--wb-x-bg-00b3ff4c, rgba(0, 179, 255, 0.3))',
                    }
                  }
                }}
                secondaryAction={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                      edge="end"
                      aria-label="edit"
                      onClick={(event) => handleEditClick(chat.session_id, chat.name, event)}
                      sx={{
                        color: 'var(--wb-x-text-b9b9b9, #b9b9b9ff)',
                        padding: '2px',
                        marginRight: '1px'
                      }}
                    >
                      <EditIcon style={{ fontSize: '16px' }} />
                    </IconButton>
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={(event) => handleDeleteClick(chat.session_id, event)}
                      sx={{
                        color: 'var(--wb-x-text-b9b9b9, #b9b9b9ff)',
                        padding: '2px',
                      }}
                    >
                      <DeleteIcon style={{ fontSize: '16px' }} />
                    </IconButton>
                  </div>
                }
              >
                <Tooltip
                  title={chat.name}
                  placement="right"
                  enterDelay={1000}
                  leaveDelay={0}
                  sx={{
                    '& .MuiTooltip-tooltip': {
                      backgroundColor: 'var(--wb-x-bg-333333, #333)',
                      color: 'var(--wb-text-strong)',
                      fontSize: '12px',
                      borderRadius: '4px',
                      maxWidth: '200px',
                      wordWrap: 'break-word'
                    }
                  }}
                >
                  <div>
                    <Typography variant="body1">
                      <ChatStreamSimulator
                        message={chat.shortName}
                        typingSpeed={20}
                      />
                    </Typography>
                  </div>
                </Tooltip>
              </ListItem>
            ))}
          </List>

        </List>
      </Drawer>

      <OnboardingDialog
        open={onboardingEnabled && profileChecked && showOnboardingDialog}
        defaults={profileDefaults}
        onSaved={async (updatedProfile) => {
          setProfileDefaults({
            companyName: updatedProfile?.companyName ?? '',
            employeesCount:
              updatedProfile?.employeesCount !== undefined && updatedProfile?.employeesCount !== null
                ? String(updatedProfile.employeesCount)
                : '',
          });
          setOnboardingDialogVisibility(false);
          setProfileChecked(true);

          // El backend acaba de asignar el grupo "admin" al crear el tenant
          // (POST /useraccount) -- refrescar la sesión para que
          // isTenantAdmin/cognitoGroups reflejen el cambio sin requerir
          // logout+login.
          if (typeof refreshSession === 'function') {
            await refreshSession();
          }

          // MUST correr DESPUÉS de refreshSession(): ese refresh
          // sobreescribe accountId desde el claim `custom:account_id` de
          // Cognito (ver DataContext.js), que puede seguir stale hasta el
          // próximo refresh de token real. create_user_account() genera
          // su propio account_id server-side (distinto del que el cliente
          // declaró al hacer signUp()) -- sin esto, un workspace creado en
          // esta misma sesión podía no aparecer en el chat hasta recargar
          // la página.
          if (updatedProfile?.accountId) {
            setAccountId(updatedProfile.accountId);
            try {
              if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('account_id', updatedProfile.accountId);
              }
            } catch (storageError) {
              console.warn('No pudimos sincronizar el account_id tras onboarding:', storageError);
            }
          }
        }}
      />

      <MfaSetupDialog
        open={mfaGateEnabled && profileChecked && showMfaDialog}
        onEnrolled={() => setMfaDialogVisibility(false)}
      />

      {/* Aviso no bloqueante -- no se pudo CONFIRMAR el estado del perfil
          (ver checkProfile/Bug B). No se muestra el onboarding a ciegas. */}
      <Snackbar
        open={profileChecked && profileCheckError}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="warning"
          onClose={() => setProfileCheckError(false)}
          action={
            <Button color="inherit" size="small" onClick={() => { setProfileCheckError(false); checkProfile(); }}>
              Reintentar
            </Button>
          }
        >
          No pudimos verificar tu perfil. Algunos datos podrían no reflejarse.
        </Alert>
      </Snackbar>

      {/* DiÃ¡logo para editar el nombre del chat */}
      <Dialog open={editDialogOpen} onClose={handleCloseEditDialog}>
        <DialogTitle>Editar nombre del chat</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nuevo nombre"
            type="text"
            fullWidth
            value={newChatName}
            onChange={(e) => setNewChatName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEditDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleSaveNewName} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleCloseDeleteDialog}
      >
        <DialogTitle>Eliminar chat</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de que deseas eliminar este chat? Esta acción no se puede deshacer
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>





      {/*********************************
         Header of Layout
         *********************************/}
      <HeaderWithDropdown
        drawerOpen={drawerOpen}
        isMobile={isMobile}
        handleDrawerToggle={handleDrawerToggle}
        userName={userName}
        handleSignOut={handleSignOut}
        onSettingsClick={handleToggleSettings}
      />

      {/* Main content */}
      <Box sx={{
        backgroundColor: 'var(--wb-x-bg-1b2535, #1B2535)',
        ml: drawerOpen && !isDrawerOverlay ? `${DRAWER_WIDTH}px` : 0,
        width: drawerOpen && !isDrawerOverlay ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%',
        transition: 'margin-left 0.3s, width 0.3s',
        // El chat ocupa exactamente la pantalla y solo su lista de mensajes
        // hace scroll; si la página también lo hiciera habría dos barras.
        // dvh sigue a la barra de direcciones del móvil; vh es el respaldo
        // para navegadores que no lo entienden.
        ...(isChatView && {
          // (En sx un arreglo serían valores por breakpoint, de ahí @supports.)
          height: '100vh',
          '@supports (height: 100dvh)': { height: '100dvh' },
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }),
      }}>

        {/***************************************************************************************
         Principal container of chat
         ****************************************************************************************/}
        <Container
          disableGutters
          maxWidth="xl"
          component="main"
          sx={{
            // Mismo alto que el encabezado fijo (ver headerHeight.js).
            pt: { xs: `${HEADER_HEIGHT.xs}px`, sm: `${HEADER_HEIGHT.sm}px` },
            ...(isChatView && {
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
            }),
          }}
        >
          {pathname === '/semanticmodel' ? (
            <SemanticModels />
          ) : showSettings ? (
            <Settings onClose={handleToggleSettings} />
          ) : isDashboardsView ? (
            <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
              {dashboardId
                ? <DashboardDetail key={dashboardId} basePath={DASHBOARDS_ROUTE} />
                : <MyDashboards basePath={DASHBOARDS_ROUTE} />}
            </Box>
          ) : (
            <Chat
              userName={userName}
              onSessionIdChange={handleSessionIdChange}
              onRequestNewSessionId={handleChatReady}
              sessionIdChange={selectedSessionId}
              onSendQuery={handleFirstQueryFromChat}
              onSendTextQuery={handleTextQueryFromChat}
            />
          )}
        </Container>


        {/*********************************
         Footer of Layout 
         (no en el chat: le quitaría alto a la lista de mensajes)
         *********************************/}
        {!isChatView && (
        <Box
          component="footer"
          sx={{
            textAlign: 'center',
            py: 2,
            px: 3,
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              letterSpacing: '0.5px',
            }}
          >
            &copy; {new Date().getFullYear()} whisperbi or its affiliates. All rights reserved.
          </Typography>
        </Box>
        )}


        {/*********************************
         Welcome Page 
         *********************************/}
        <Dialog
          fullWidth
          maxWidth="xl"
          open={open}
          onClose={handleClose}
          PaperProps={{
            sx: {
              borderRadius: 4,
              bgcolor: 'background.default',
              boxShadow: 12,
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              color: 'text.primary',
              fontSize: '1.5rem',
              pb: 1,
            }}
          >
            Amazon Bedrock
          </DialogTitle>
          <DialogContent
            sx={{
              px: 2,
              pt: 0,
              pb: 2,
            }}
          >
            <Slide
              autoplay={false}
              transitionDuration={500}
              onChange={() => { }}
              onStartChange={() => { }}
            >
              {[
                'gen-ai-assistant-diagram.png',
                'gen-ai-assistant-bedrock.png',
                'gen-ai-assistant-agent.png',
                'gen-ai-assistant-agent-flow.png',
              ].map((img, index) => (
                <Box key={index} className="each-slide-effect">
                  <Box
                    component="img"
                    src={`/images/${img}`}
                    alt={`Bedrock Slide ${index + 1}`}
                    sx={{
                      width: '100%',
                      borderRadius: 2,
                      objectFit: 'contain',
                      boxShadow: 3,
                    }}
                  />
                </Box>
              ))}
            </Slide>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              sx={{
                borderRadius: 2,
                fontWeight: 500,
                textTransform: 'none',
              }}
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

      </Box>

    </ThemeProvider>
  );
}

export default LayoutApp;






